import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import ViewIssue from "./viewAllIssues";

import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
function AnalystIssueManagement() {
  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [viewIssues, setViewIssues] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [risk, setRiskData] = useState([]);
  const { sendRequest: getViewAllIssuesAPI } = useHttp();
  const { sendRequest: getAssessmentDataAPI } = useHttp();
  const { sendRequest: getAllVendorListAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getManageRiskData } = useHttp();

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };
  const getAllViewIssuesData = async () => {
    await getViewAllIssuesAPI(APIService.getViewAllIssues(), (data) => {
      data.MSG.forEach(function (a) {
        a.created_date = a.created_date.substring(0, 10);
        a.issuedue_date = a.issuedue_date.substring(0, 10);
      });
      setViewIssues(data.MSG);
    });
  };
  const getAllVendorListData = async () => {
    getAllVendorListAPI(APIService.getAllVendorList(), (data) => {
      setVendors(data.MSG);
    });
  };
  const getAssessmentDetails = async () => {
    await getAssessmentDataAPI(APIService.getAssessmentData(), (data) =>
      setAssessment(data.MSG)
    );
  };
  const getRiskData = async () => {
    getManageRiskData(
      APIService.getManageRiskData(),
      (data) => {
        setRiskData(data.MSG);
      }
    );
  };
  useEffect(() => {
    getAllViewIssuesData();
    getAllVendorListData();
    getAssessmentDetails();
    getRiskData();
  }, []);

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label=" View All Issues">
          <ViewIssue
            reset={reset}
            reload={getAllViewIssuesData}
            viewIssues={viewIssues}
            vendors={vendors}
            assessment={assessment}
            risk={risk}
          />
        </Tab>
        {/* <Tab value="2" label=" View Update Requests">
          <UpdateIssue reset={reset} />
        </Tab> 
        <Tab value="3" label=" View Action Requests">
          <ActionIssue reset={reset}  />
        </Tab>    */}
      </Tabs>
    </div>
  );
}
export default AnalystIssueManagement;
